module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.goodsList), function(goods, index) {
    return _c('div', {
      staticClass: "coms-goods flex-start",
      on: {
        "click": function($event) {
          return _vm.goGoodsDetail(goods.url.name, goods.url.query.id)
        }
      }
    }, [_c('img', {
      staticClass: "coms-left",
      attrs: {
        "src": goods.goods.pic_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "coms-right"
    }, [_c('div', {
      staticClass: "coms-good-name"
    }, [_vm._v(_vm._s(goods.goods.title))]), _vm._v(" "), _c('div', {
      staticClass: "coms-good-detail flex-between"
    }, [_c('div', {
      staticClass: "flex-start"
    }, [_c('div', {
      staticClass: "good-normal-price"
    }, [_c('span', [_vm._v("¥")]), _vm._v("\n            " + _vm._s(goods.goods.price_range[0]) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "good-thr-price"
    }, [_c('span', [_vm._v("¥")]), _vm._v("\n            " + _vm._s(goods.goods.orig_price) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "coms-sell-num"
    }, [_vm._v("已售 " + _vm._s(goods.goods.sold_count + goods.goods.sold_show_count))])]), _vm._v(" "), (goods.goods.max_seller_reward > 0) ? _c('div', {
      staticClass: "good-pri-earn",
      staticStyle: {
        "margin": "4px 0 4px 0"
      }
    }, [_vm._v("分享可赚￥" + _vm._s(goods.goods.max_seller_reward))]) : _vm._e(), _vm._v(" "), (goods.goods.discount_tags.length > 0) ? _c('div', {
      staticClass: "coms-tips"
    }, _vm._l((goods.goods.discount_tags), function(tag, index) {
      return _c('div', {
        staticClass: "coms-tips-one flex-start"
      }, [_c('div', {
        staticClass: "coms-tips-type coms-tips-typeq",
        style: ('background:' + tag.color),
        domProps: {
          "innerHTML": _vm._s(tag.title)
        }
      }, [_vm._v(_vm._s(tag.tag))]), _vm._v("\n          " + _vm._s(tag.title) + "\n        ")])
    }), 0) : _vm._e()])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dce800b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/GoodsItem1.vue
// module id = 2499
// module chunks = 0